import React from "react";
import PropTypes from "prop-types";

import { useTrans, useModal } from "../hooks";
import { Icon, MODAL_ID } from "../shared-components";
import { Button, ButtonVariant } from "@wattpad/web-ui-library";

const EditWorksButtons = ({
  draft,
  onPublish,
  onPreview,
  onPreviewUnpublished,
  onSave,
  onCancel,
  isScheduledPart
}) => {
  const { trans } = useTrans();
  const publishModal = useModal(MODAL_ID.PUBLISH_MODAL_ID);

  return (
    <div className="button-container">
      {isScheduledPart ? (
        <button className="btn publish-btn" onClick={publishModal.show}>
          <Icon
            name="calendar"
            size="20"
            color="ds-neutral-00-solid"
            className="calendar-icon"
          />
          {trans("Change schedule")}
        </button>
      ) : draft ? (
        <button className="btn publish-btn" onClick={onPublish}>
          {trans("Publish")}
        </button>
      ) : (
        <button className="btn publish-btn" onClick={onPreview}>
          {trans("Publish Changes")}
        </button>
      )}

      {draft ? (
        <>
          <Button onClick={onSave} variant={ButtonVariant.SECONDARY}>
            {trans("Save")}
          </Button>
          <Button
            onClick={onPreviewUnpublished}
            variant={ButtonVariant.SECONDARY}
          >
            {trans("Preview")}
          </Button>
        </>
      ) : (
        <Button onClick={onCancel} variant={ButtonVariant.SECONDARY}>
          {trans("Cancel")}
        </Button>
      )}
    </div>
  );
};

EditWorksButtons.propTypes = {
  draft: PropTypes.bool.isRequired,
  onPublish: PropTypes.func,
  onSave: PropTypes.func,
  onPreview: PropTypes.func,
  onPreviewUnpublished: PropTypes.func,
  onCancel: PropTypes.func,
  isScheduledPart: PropTypes.bool
};

export default EditWorksButtons;
